import {
  FETCH_TASK_TEMPLATES_REQUEST,
  FETCH_TASK_TEMPLATES_SUCCESS,
  FETCH_TASK_TEMPLATES_FAILURE,
  CREATE_TASK_TEMPLATE_SUCCESS,
  DELETE_TASK_TEMPLATE_SUCCESS,
} from '../actions/taskTemplatesActions';

const initialState = {
  items: [],
  total: 0,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case FETCH_TASK_TEMPLATES_REQUEST:
    return { ...state, loading: true, error: null };

  case FETCH_TASK_TEMPLATES_SUCCESS:
    return {
      ...state,
      items: action.payload.items,
      total: action.payload.total,
      loading: false,
      error: null,
    };

  case FETCH_TASK_TEMPLATES_FAILURE:
    return { ...state, loading: false, error: action.payload };

  case CREATE_TASK_TEMPLATE_SUCCESS:
    return {
      ...state,
      items: [action.payload, ...state.items],
      total: state.total + 1,
    };

  case DELETE_TASK_TEMPLATE_SUCCESS:
    return {
      ...state,
      items: state.items.filter((tpl) => tpl.id !== action.payload.id),
      total: Math.max(0, state.total - 1),
    };

  default:
    return state;
  }
};
